import React from 'react';

/**
 * Reusable ImageView Component
 * @param {string} src - Image source URL or path
 * @param {string} alt - Alt text for image
 * @param {string} width - Image width (px, %, etc.)
 * @param {string} height - Image height (px, %, etc.)
 * @param {string} objectFit - Object fit (contain, cover, fill, none, scale-down)
 * @param {string} borderRadius - Border radius (px, %, etc.)
 * @param {string} margin - Margin (px, rem, etc.)
 * @param {string} padding - Padding (px, rem, etc.)
 * @param {string} border - Border (e.g., "1px solid black")
 * @param {string} backgroundColor - Background color
 * @param {string} className - Additional CSS class
 * @param {object} style - Additional inline styles
 */
const ImageView = ({
  src,
  alt = 'Image',
  width = 'auto',
  height = 'auto',
  objectFit = 'contain',
  borderRadius = '0',
  margin = '0',
  padding = '0',
  border = 'none',
  backgroundColor = 'transparent',
  className = '',
  style = {},
  onClick,
  ...props
}) => {
  const imageStyle = {
    width,
    height,
    objectFit,
    borderRadius,
    margin,
    padding,
    border,
    backgroundColor,
    display: 'block',
    ...style
  };

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={imageStyle}
      onClick={onClick}
      {...props}
    />
  );
};

export default ImageView;
